import StackedAlert from './StackedAlert';

export default StackedAlert;
